import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=48c54584&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&id=48c54584&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c54584",
  null
  
)

export default component.exports